/* eslint-enable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState, useRef, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import Select from "react-select";
import { all_routes } from "../../Router/all_routes";
import { bucketObj } from "../../environment";
import countriesData from "../../core/json/countries.json";
// import socialMediaData from "../../core/json/socialMedia.json";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import ImageWithBasePath, {
  uploadImageNewWithName,
  getImageName,
  uploadImageNew,
} from "../../core/img/imagewithbasebath";
import { toBlob } from "html-to-image";
// import ImageToVideoCanvas from "./ImageToVideoCanvas";
import { ReactPhotoCollage } from "react-photo-collage";

import {
  ArrowLeft,
  ChevronDown,
  ChevronUp,
  Info,
  PlusCircle,
  X,
} from "feather-icons-react/build/IconComponents";
import Spinner from "../loader/spinner";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import axios from "axios";
import { setToogleHeader, set_store_list } from "../../core/redux/action";
import { APIgetStores } from "../../api/settings.ts";

const YT_CATEGORIES = [
  { value: "1",  label: "Film & Animation" },
  { value: "2",  label: "Autos & Vehicles" },
  { value: "10", label: "Music" },
  { value: "15", label: "Pets & Animals" },
  { value: "17", label: "Sports" },
  { value: "19", label: "Travel & Events" },
  { value: "20", label: "Gaming" },
  { value: "22", label: "People & Blogs" },
  { value: "23", label: "Comedy" },
  { value: "24", label: "Entertainment" },
  { value: "25", label: "News & Politics" },
  { value: "26", label: "Howto & Style" },
  { value: "27", label: "Education" },
  { value: "28", label: "Science & Technology" },
];

const YT_PRIVACY = [
  { value: "public",   label: "Public" },
  // { value: "unlisted", label: "Unlisted" },
  // { value: "private",  label: "Private" },
];

// const LANGUAGES = [
//   { value: "en", label: "English" },
//   { value: "ja", label: "Japanese" },
//   { value: "ur", label: "Urdu" },
//   { value: "ar", label: "Arabic" },
//   { value: "fr", label: "French" },
//   { value: "de", label: "German" },
//   { value: "es", label: "Spanish" },
// ];

const AddSocialVideoSchedulingAi = () => {
  const route = all_routes;
  const MySwal = withReactContent(Swal);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // --- Redux state ---
  const l = useSelector((s) => s.language || "en");
  const t = useSelector((s) => s.translation || "en");
  const data = useSelector((s) => s.toggle_header);
  const prodData = useSelector((s) => s.gateway_edit);
  const storesFromRedux = useSelector((s) => s.store_list || []);

  // --- Local UI state ---
  const [btnLoading, setBtnLoading] = useState(false);
  const [isAutoPosting, setIsAutoPosting] = useState(false);
  const [allProductList, setAllProductList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [videoUrl, setVideoUrl] = useState("");
  // const [ytThumbUrl, setYtThumbUrl] = useState("");
  const [imageLoading, setImageLoading] = useState(0);
  const [enabled, setEnabled] = useState(false);
  
  // unified product state (single source of truth)
  const [product, setProduct] = useState({
    postingType: "video",
    scheduleType: "none",
    youtubeMeta: {
      title: "",
      description: "",
      // tagsCsv: "",
      categoryId: "",
      privacyStatus: "public",
      madeForKids: false,
      defaultLanguage: "",
      thumbnailUrl: "",
    },
  });

  // --- Derived, memoized values ---
  const storeOptions = useMemo(
    () =>
      [{ label: t?.[l]?.["choose"] || "Choose", value: "choose" }].concat(
        storesFromRedux.map((itm) => ({ label: itm.name, value: itm._id }))
      ),
    [storesFromRedux, l, t]
  );

  const postingType = useMemo(
    () => [
      { value: "video", label: "Video/Reel/Shorts", name: "Video" }
    ],
    []
  );

  const tenantId = useMemo(() => localStorage.getItem("tenantWebId"), []);
  const countriesOptions = useMemo(() => {
    const base = [
      {
        value: "select_country",
        label: t?.[l]?.["Select Country"] || "Select Country",
        name: "Select Country",
      },
    ];
    const list =
      tenantId === "n4Xc96g6qyNcrq5dD" || tenantId === "jNrhXAynhAbQkrj8Y"
        ? countriesData.filter((f) => f.value === "Japan")
        : countriesData;

    return base.concat(
      list.map((country) => ({
        value: country.name,
        label: t?.[l]?.[country.name] || country.name,
      }))
    );
  }, [tenantId, l, t]);

  // Base options from JSON (+ ensure youtube is present)
  const baseSocialOptions = useMemo(() => {
    // const firstKey = Object.keys(socialMediaData)[0];
    const arr = [];//socialMediaData?.[firstKey] || [];
    // const ensureYT = arr.includes("youtube") ? [] : [{ value: "youtube", label: t?.[l]?.["youtube"] || "youtube" }];
    return [
      {
        value: "select_platform",
        label: t?.[l]?.["Select Platform"] || "Select Platform",
      },
      ...arr.map((p) => ({ value: p, label: t?.[l]?.[p] || p })),
      // ...ensureYT,
    ];
  }, [l, t]);

  const [socialMediaOptions, setSocialMediaOptions] = useState(baseSocialOptions);
  useEffect(() => {
    setIsAutoPosting(false);
    setSocialMediaOptions(baseSocialOptions);
  }, [baseSocialOptions]);

  // collage
  const [selectedProducts, setSelectedProducts] = useState([]);
  const collageRef = useRef(null);

  // --- Helpers ---
  const goBack = () => navigate("/socialmedia-video-scheduling-ai");
  const renderCollapseTooltip = (props) => <Tooltip id="refresh-tooltip" {...props}>Collapse</Tooltip>;

  const toAbs = useCallback((u) => {
    if (!u) return null;
    return u.startsWith("http") ? u : bucketObj.bucketUrl + bucketObj.objectKey + u;
  }, []);

  const platformsList = (product.platforms || []).map(String);
  const hasPlatform = useCallback(
    (slug) => platformsList.some((p) => p === slug || p.startsWith(`${slug}-`)),
    [platformsList]
  );

  const isYoutubeSelected = hasPlatform("youtube"); // NEW
  const isNonYoutubeSelected =
  hasPlatform("facebook") || hasPlatform("instagram") || hasPlatform("tiktok") || hasPlatform("twitter") || hasPlatform("linkedin");
  // --- API calls (memoized) ---
  const getStoreData = useCallback(async () => {
    const res = await APIgetStores({});
    const storeData = res?.response?.stores || [];
    const storeOptionsMapped = storeData.slice().reverse().map((s) => ({
      name: s.title,
      _id: s._id,
      storeCode: s.storeNumber,
    }));
    dispatch(set_store_list(storeOptionsMapped));
  }, [dispatch]);

  const getProductData = useCallback(async () => {

    const storeIds = localStorage.getItem("storeIds");
    if (!storeIds) return;
    if(storeIds == "123")
    {
      const res = await axios.get("getuserinventory/", { params: { storeIds } });
      const list = res?.data?.productList || [];

      setAllProductList(
        list.map((p) => ({
          name: p.name,
          _id: p._id,
          img: p.imgUrls?.[0] || null,
          imgList: p.imgUrls || [],
          storeId: p.storeId,
        }))
      );
    }
    else
    {
       setAllProductList([]);
    }
  }, []);

  const getProductDataByStoreId = useCallback(
    (storeId) => {
      if (!storeId) return;
      const productOptions = allProductList.filter((p) => p.storeId === storeId);
      setProductList([
        {
          value: "select_product",
            label: t?.[l]?.["Select Product"] || "Select Product",
            name: "Select Product",
        },
        ...productOptions.map((pp) => {
          const first = toAbs(pp.img);
          return {
            value: pp._id,
            imgSrc: first,
            label: (
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                {first && (
                  <ImageWithBasePath
                    src={first}
                    alt={pp.name}
                    absolutePath="true"
                    className="img-fluid-phone-img"
                    style={{ width: 40, height: 40, objectFit: "cover", borderRadius: 5 }}
                  />
                )}
                <span style={{ fontSize: 14, fontWeight: 500, color: "#333" }}>{pp.name}</span>
              </div>
            ),
            name: pp.name,
            imgSrcList: (pp.imgList || []).map(toAbs),
          };
        }),
      ]);
    },
    [allProductList, l, t, toAbs]
  );

  // 🔸 UPDATED: also pull YouTube channels
 const updateSocialMediaOptions = useCallback(
  async (country, storeId) => {
    let next = [...baseSocialOptions];

    try {
      // 🔸 one request for all platforms (FB, IG, YT)
      const { data } = await axios.get("getpagetokens", {
        params: {
          storeId,
          country,
          socialMediaType: "facebook,instagram,youtube,tiktok", // comma-separated
        },
      });

      const rows = data?.data || [];

      // normalize into options
      const newOptions = rows.map((item) => ({
        value: `${item.provider}-${item.id}`, // e.g., facebook-123, youtube-abc
        label: `${item.name} (${item.provider})`,
      }));

      next = next.concat(newOptions);
    } catch (err) {
      console.error("updateSocialMediaOptions error:", err);
      // ignore; keep base options
    }

    setSocialMediaOptions(next);
  },
  [baseSocialOptions]
);

  // --- Effects ---
  useEffect(() => { (async () => { await getStoreData(); await getProductData(); })(); }, [getStoreData, getProductData]);

  useEffect(() => {
    if (prodData?.viewOnly === true) setEnabled(true);
    if (prodData) setProduct((prev) => ({ ...prev, ...prodData }));
  }, [prodData]);

  useEffect(() => {
    if (isAutoPosting) setProduct((p) => ({ ...p, storeId: "", storeName: "" }));
  }, [isAutoPosting]);

  // --- Handlers ---
  const handleInputChange = useCallback(
    (e) => {
      const { name, value: raw, type, checked } = e.target;
      const restrictedChars = /[%?\\/]/g;

      // handle nested youtubeMeta.* fields
      if (name?.startsWith("youtubeMeta.")) {
        const key = name.split("youtubeMeta.")[1];
        setProduct((prev) => ({
          ...prev,
          youtubeMeta: {
            ...prev.youtubeMeta,
            [key]: type === "checkbox" ? !!checked : raw,
          },
        }));
        return;
      }

      const value = name === "title" ? raw.replace(restrictedChars, "") : raw;
      setProduct((prev) => ({ ...prev, [name]: value }));

      if (name === "storeId" && product.country && value) {
        updateSocialMediaOptions(product.country, value);
        if (!isAutoPosting && !isYoutubeSelected) getProductDataByStoreId(value);
      }
      if (name === "country" && product.storeId) {
        updateSocialMediaOptions(value, product.storeId);
      }
    },
    [getProductDataByStoreId, updateSocialMediaOptions, product.country, product.storeId, isAutoPosting]
  );

  const onProductsChange = useCallback((opts) => {
    if (opts.length > 4) return;
    setSelectedProducts(opts);
    setProduct((p) => ({ ...p, product: opts.map((o) => o.value) }));
  }, []);

  // Collage setup
  const collageSetting = useMemo(() => {
    if (!selectedProducts?.length || product.postingType !== "collage") return null;

    const imgsOf = (opt) =>
      opt.imgSrcList?.length ? opt.imgSrcList : opt.imgSrc ? [opt.imgSrc] : [];

    let photos = [];
    let layout = [2, 2];
    let height = ["250px", "170px"];

    if (selectedProducts.length === 1) {
      const list = imgsOf(selectedProducts[0]).map((src) => ({ source: src }));
      photos = list;
      const c = list.length || 1;
      layout = [1, c];
      height = ["540px", "540px"];
    } else {
      const list = selectedProducts.map((p) => ({ source: p.imgSrc })).filter((x) => !!x.source);
      photos = list;
      const c = list.length;
      if (c <= 2) layout = [1, 1];
      else if (c === 3) { layout = [1, 2]; height = ["750px", "750px"]; }
      else layout = [2, 2];
      if (c === 4) height = ["540px", "540px"];
    }

    return { width: "100%", height, layout, photos, showNumOfRemainingPhotos: true };
  }, [selectedProducts, product.postingType]);

  const reelImages = useMemo(() => {
    if (product.postingType !== "reel" || !selectedProducts?.length) return [];
    const imgsOf = (opt) => opt.imgSrcList?.length ? opt.imgSrcList : opt.imgSrc ? [opt.imgSrc] : [];
    if (selectedProducts.length === 1) return imgsOf(selectedProducts[0]).map((src) => ({ source: src }));
    return selectedProducts.map((p) => p.imgSrc).filter(Boolean).map((src) => ({ source: src }));
  }, [selectedProducts, product.postingType]);
  console.log("reelImages",reelImages);

  const generateCollage = useCallback(async (name) => {
    const el = collageRef.current;
    if (!el) return;
    const blob = await toBlob(el, { cacheBust: true });
    if (blob) {
      blob.name = "ReactPhotoCollage.png";
      await uploadImageNewWithName(blob, name);
    }
  }, []);

  // --- Upload handlers ---
  async function handleVideoUpload(event) {
    try {
      if (event.target.files.length) {
        const file = event.target.files[0];
        // 20 MB limit (adjust if needed)
        if (file.size > 1024 * 1024 * 1024) {
          alert(t?.[l]?.["file_size_exceeds_1_GB_limit"] || "File size exceeds 1 GB limit");
          event.target.value = "";
          return;
        }
        setImageLoading(1);
        const name = await uploadImageNew(file, "socailMediaScheduling", "video");
        event.target.value = "";
        setVideoUrl(name);
        setProduct((prev) => ({ ...prev, reelUrl: name }));
        setImageLoading(0);
      }
    } catch (error) {
      console.error("Error uploading video:", error);
    }
  }

  // async function handleYtThumbUpload(event) {
  //   try {
  //     if (event.target.files.length) {
  //       const file = event.target.files[0];
  //       const name = await uploadImageNew(file, "socailMediaScheduling", "thumbnail");
  //       setYtThumbUrl(name);
  //       setProduct((prev) => ({
  //         ...prev,
  //         youtubeMeta: { ...prev.youtubeMeta, thumbnailUrl: name },
  //       }));
  //     }
  //   } catch (e) {
  //     console.error("Error uploading thumbnail:", e);
  //   }
  // }

  const handleRemoveVideo = () => {
    setVideoUrl("");
    setProduct((prev) => ({ ...prev, reelUrl: null }));
  };

  // --- Submit ---
  const submit = useCallback(
  async (event) => {
    event.preventDefault();
    event.stopPropagation();

    try {
      let postingUrl;

      if (product.postingType === "collage") {
        const name = getImageName("ReactPhotoCollage.png", "socialmedia", "img");
        await generateCollage(name);
        postingUrl = name;
      }

      setBtnLoading(true);

      const finalProduct = { ...product };
      const platforms = Array.isArray(finalProduct.platforms)
        ? finalProduct.platforms.map(String)
        : finalProduct.platforms
        ? [String(finalProduct.platforms)]
        : [];
      finalProduct.platforms = platforms;

      // schedule validation
      const now = new Date();
      now.setMilliseconds(0);
      now.setSeconds(0);

      if (finalProduct.scheduleType && finalProduct.scheduleType !== "now" && finalProduct.scheduleTime) {
        const [hh, mm] = String(finalProduct.scheduleTime).split(":");
        const sched = new Date();
        if (finalProduct.scheduleDate) {
          const d = new Date(finalProduct.scheduleDate);
          sched.setFullYear(d.getFullYear(), d.getMonth(), d.getDate());
        }
        sched.setHours(+hh || 0, +mm || 0, 0, 0);
        if (sched < new Date(now.getTime() + 2 * 60 * 1000)) {
          setBtnLoading(false);
          return MySwal.fire({
            icon: "error",
            title: "Pick a future time (≥10 minutes ahead)",
            timer: 2500,
            showConfirmButton: false,
          });
        }
        finalProduct.isInstant = false;
      } else {
        finalProduct.isInstant = finalProduct.scheduleType === "now" || !finalProduct.scheduleType;
      }

      // page/channel presence
      const hasFbRaw = platforms.includes("facebook");
      const hasIgRaw = platforms.includes("instagram");
      const hasYtRaw = platforms.includes("youtube");
      const hasTtRaw = platforms.includes("tiktok");

      const hasFbPage = platforms.some((p) => p?.startsWith?.("facebook-"));
      const hasIgPage = platforms.some((p) => p?.startsWith?.("instagram-"));
      const hasYtChannel = platforms.some((p) => p?.startsWith?.("youtube-"));
      const hasTtChannel = platforms.some((p) => p?.startsWith?.("tiktok-"));

      // If selecting any platform that requires a page/channel/account, ensure user selected one
      if (
        (hasFbRaw && !hasFbPage && !finalProduct.page) ||
        (hasIgRaw && !hasIgPage && !finalProduct.page) ||
        (hasYtRaw && !hasYtChannel && !finalProduct.channelId) ||
        (hasTtRaw && !hasTtChannel && !finalProduct.channelId && !finalProduct.page)
      ) {
        setBtnLoading(false);
        return MySwal.fire({
          icon: "warning",
          title: "Please select a page/channel/account",
          timer: 2200,
          showConfirmButton: false,
        });
      }

      // derive channelId if user selected youtube-xxx
      if (!finalProduct.channelId) {
        const ytPick = platforms.find((p) => p.startsWith?.("youtube-"));
        if (ytPick) finalProduct.channelId = ytPick.split("youtube-")[1];
      }

      // // derive channelId if user selected tiktok-xxx
      // if (!finalProduct.channelId) {
      //   const ttPick = platforms.find((p) => p.startsWith?.("tiktok-"));
      //   if (ttPick) finalProduct.channelId = ttPick.split("tiktok-")[1];
      // }

      // Always attach common
      finalProduct.userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      finalProduct.postingUrl = postingUrl;
      finalProduct.reelUrl = videoUrl || undefined;
      finalProduct.aiPromptFromSheet =
        t?.[l]?.["post_ai_prompt"] || "Please write social media post, max 100 words.";
      finalProduct.auto = isAutoPosting;

      // If any of FB/IG/YT/TT selected, allow (and for YT/TT, require) video
      const wantsVideo =
        hasFbRaw ||
        hasFbPage ||
        hasIgRaw ||
        hasIgPage ||
        hasYtRaw ||
        hasYtChannel ||
        hasTtRaw;

      // YouTube-specific validations
      if (hasYtRaw || hasYtChannel) {
        const m = finalProduct.youtubeMeta || {};
        if (!finalProduct.reelUrl) {
          setBtnLoading(false);
          return MySwal.fire({ icon: "warning", title: "Please attach a video for YouTube", timer: 2200, showConfirmButton: false });
        }
        if (!m.title?.trim()) {
          setBtnLoading(false);
          return MySwal.fire({ icon: "warning", title: "YouTube title is required", timer: 2000, showConfirmButton: false });
        }
        if (!m.privacyStatus) {
          setBtnLoading(false);
          return MySwal.fire({ icon: "warning", title: "Select YouTube privacy", timer: 2000, showConfirmButton: false });
        }
        if (!m.categoryId) {
          setBtnLoading(false);
          return MySwal.fire({ icon: "warning", title: "Choose a YouTube category", timer: 2000, showConfirmButton: false });
        }

        finalProduct.youtubeMeta = {
          ...m,
        };
      }

      // TikTok-specific validations
      if (hasTtRaw || hasTtChannel) {
        const m = finalProduct.tiktokMeta || {};

        // TikTok requires a vertical video; ensure a video is attached
        if (!finalProduct.reelUrl) {
          setBtnLoading(false);
          return MySwal.fire({ icon: "warning", title: "Please attach a video for TikTok", timer: 2200, showConfirmButton: false });
        }

        // If user intends to run a TikTok Ad (flag in tiktokMeta), validate ad-related fields
        if (m.isAd) {
          // require adAccountId and at least one ad creative field (headline/cta/campaign) — adjust to your backend's required shape
          if (!m.adAccountId) {
            setBtnLoading(false);
            return MySwal.fire({ icon: "warning", title: "Select a TikTok Ad account", timer: 2200, showConfirmButton: false });
          }
          if (!m.campaignName && !m.adName) {
            setBtnLoading(false);
            return MySwal.fire({
              icon: "warning",
              title: "Provide campaign or ad name for TikTok Ad",
              timer: 2200,
              showConfirmButton: false,
            });
          }
          // optional: require objective
          if (!m.objective) {
            setBtnLoading(false);
            return MySwal.fire({
              icon: "warning",
              title: "Choose a TikTok ad objective",
              timer: 2200,
              showConfirmButton: false,
            });
          }
        }

        // Normalize/store tiktokMeta
        finalProduct.tiktokMeta = {
          ...m,
        };
      }

      // For FB/IG posting a video, we simply include reelUrl (already handled)
      if (wantsVideo && !finalProduct.reelUrl) {
        // soft warning only if YT/TT not selected — keep as before
      }

      const res = await axios.post("addorupdatescheduledpostai/", finalProduct);
      setBtnLoading(false);
      if (res) {
        await MySwal.fire({
          position: "top-end",
          icon: "success",
          title: "Post added successfully!",
          timer: 2000,
          showConfirmButton: false,
        });
        goBack();
      }
    } catch (err) {
      setBtnLoading(false);
      MySwal.fire({
        position: "top-end",
        icon: "error",
        title: err?.response?.data?.message || "Error",
        showConfirmButton: false,
        timer: 3000,
      });
    }
  },
  [MySwal, generateCollage, isAutoPosting, l, t, product, videoUrl]
);


  // Show the video uploader when any of these are selected OR if postingType === 'reel'
  const showVideoUploader =
    product.postingType === "reel" ||
    product.postingType === "video" ||   // NEW

    hasPlatform("facebook") ||
    hasPlatform("instagram") ||
    hasPlatform("youtube") || hasPlatform("tiktok");

  const showYoutubeMeta = hasPlatform("youtube");

  return (
    <div className={`${l === "ar" ? "page-wrapper-rtl" : "page-wrapper"}`}>
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>{t?.[l]?.["new_post"] || "New Post"}</h4>
              <h6>{t?.[l]?.["create_new_post"] || "Create new post"}</h6>
            </div>
          </div>
          <ul className="table-top-head">
            <li>
              <div className="page-btn">
                <Link to={route.productlist} className="btn btn-secondary">
                  <ArrowLeft className="me-2" />
                  {t?.[l]?.["back_to_post"] || "Back to Post"}
                </Link>
              </div>
            </li>
            <li>
              <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                <Link
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Collapse"
                  id="collapse-header"
                  className={data ? "active" : ""}
                  onClick={() => {
                    dispatch(setToogleHeader(!data));
                  }}
                >
                  <ChevronUp className="feather-chevron-up" />
                </Link>
              </OverlayTrigger>
            </li>
          </ul>
        </div>

        <form onSubmit={submit}>
          <div className="card">
            <div className="card-body add-product pb-0">
              <div className="accordion-card-one accordion" id="accordionExample">
                <div className="accordion-item">
                  <div className="accordion-header" id="headingOne">
                    <div
                      className="accordion-button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseOne"
                      aria-controls="collapseOne"
                    >
                      <div className="addproduct-icon">
                        <h5>
                          <Info className="add-info" />
                          <span>{t?.[l]?.["post_information"] || "Post Information"}</span>
                        </h5>
                        <Link to="#"><ChevronDown className="chevron-down-add" /></Link>
                      </div>
                    </div>
                  </div>

                  <div
                    id="collapseOne"
                    className="accordion-collapse collapse show"
                    aria-labelledby="headingOne"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      <div className="addservice-info">
                        <div className="row">
                          <div className="col-12">
                            {/* Posting type + Auto posting */}
                            <div className="mb-3 add-product produt-name-type d-flex align-items-center flex-wrap">
                              <div className="col-lg-6 col-12 mb-3">
                                <div className="me-4">
                                  <label className="form-label">
                                    {t?.[l]?.["posting_type"] || "Posting Type"} <span>*</span>
                                  </label>
                                  <Select
                                    className="select"
                                    options={postingType}
                                    name="postingType"
                                    isDisabled={isAutoPosting}
                                    value={ postingType.find((o) => o.value === product.postingType) || postingType[0] }
                                    onChange={(opt) => {
                                      handleInputChange({ target: { name: "postingType", value: opt.value } });
                                    }}
                                    styles={{
                                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                      menu: (base) => ({ ...base, zIndex: 9999 }),
                                    }}
                                  />
                                </div>
                              </div>

                            </div>

                            {/* Country + Store */}
                            <div className="mb-3 add-product produt-name-type d-flex align-items-center flex-wrap">
                              <div className="col-lg-6 col-12 mb-3">
                                <div className="me-4">
                                  <label className="form-label">{t?.[l]?.["country"] || "Country"} <span>*</span></label>
                                  <Select
                                    className="select"
                                    options={countriesOptions}
                                    name="country"
                                    value={countriesOptions.find((o) => o.value === product.country) || countriesOptions[0]}
                                    onChange={(opt) => {
                                      handleInputChange({ target: { name: "country", value: opt.value } });
                                    }}
                                    styles={{
                                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                      menu: (base) => ({ ...base, zIndex: 9999 }),
                                    }}
                                  />
                                </div>
                              </div>
                              <div className="col-lg-6 col-12 mb-3">
                                <div className="me-4">
                                  <label className="form-label">{t?.[l]?.["store"] || "Store"} <span>*</span></label>
                                  <Select
                                    className="select"
                                    options={storeOptions}
                                    placeholder={t?.[l]?.["choose"] || "Choose"}
                                    required
                                    value={storeOptions.filter((o) => o?.value === product.storeId)}
                                    onChange={(v) => {
                                      handleInputChange({ target: { name: "storeId", value: v.value } });
                                      handleInputChange({ target: { name: "storeName", value: v.label } });
                                      if (!isAutoPosting) getProductDataByStoreId(v.value);
                                    }}
                                    styles={{
                                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                      menu: (base) => ({ ...base, zIndex: 9999 }),
                                    }}
                                  />
                                </div>
                              </div>
                            </div>

                            {/* Product select (hidden in auto mode) */}
                            {!isAutoPosting && !isYoutubeSelected  && (
                              <span style={{display: "none"}}>
                                <div className="mb-3 add-product produt-name-type d-flex align-items-center flex-wrap">
                                  <div className="col-lg-12 col-12 mb-3">
                                    <div className="me-4">
                                      <label className="form-label">{t?.[l]?.["select_product"] || "Select Product"}</label>
                                      <Select
                                        className="select"
                                        options={productList}
                                        name="product"
                                        isMulti
                                        value={productList.filter((o) => (product.product || []).includes(o.value))}
                                        onChange={onProductsChange}
                                    styles={{
                                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                      menu: (base) => ({ ...base, zIndex: 9999 }),
                                    }}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </span>
                            )}

                            {/* Platforms */}
                            <div className="mb-3 add-product produt-name-type d-flex align-items-center flex-wrap">
                              <div className="col-lg-12 col-12 mb-3">
                                <div className="me-4">
                                  <label className="form-label">
                                    {t?.[l]?.["platform"] || "Platform"} <span>*</span>
                                  </label>
                                  <Select
                                    className="select"
                                    options={socialMediaOptions}
                                    name="platforms"
                                    isMulti
                                    required
                                    value={socialMediaOptions.filter((o) => (product.platforms || []).includes(o.value))}
                                    // onChange={(opts) => setProduct((p) => ({ ...p, platforms: opts.map((o) => o.value) }))}
                                    onChange={(opts) => {
                                      const nextPlatforms = opts.map((o) => o.value);
                                      const nextIncludesYoutube = nextPlatforms.some(
                                        (v) => v === "youtube" || v?.startsWith?.("youtube-")
                                      );
                                      setProduct((p) => ({
                                        ...p,
                                        platforms: nextPlatforms,
                                        // Auto-clear products if YouTube picked
                                        ...(nextIncludesYoutube ? { product: [], } : {}),
                                      }));
                                    }}
                                    styles={{
                                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                      menu: (base) => ({ ...base, zIndex: 9999 }),
                                    }}
                                  />
                                </div>
                              </div>
                            </div>

                            {/* Video upload / generator — now shown for FB/IG/YT or reel */}
                            <div className="mb-3 add-product produt-name-type d-flex align-items-center flex-wrap">
                              {showVideoUploader && (
                                <div className="col-lg-12 col-12 mb-3">
                                  <div className="me-4">
                                    <label className="form-label">{t?.[l]?.["upload_video"] || "Upload Video"}</label>

                                    {/* {product.postingType === "reel" && (
                                      <ImageToVideoCanvas imageUrls={reelImages} onVideoGenerated={setVideoUrl} />
                                    )} */}

                                    <div className="input-blocks">
                                      {/* <div className="image-upload">
                                        <input
                                        className="video_upload"
                                          type="file"
                                          accept="video/mp4,video/webm,video/ogg,video/avi,video/mov,video/mkv"
                                          onChange={handleVideoUpload}
                                        />
                                        <div className="image-uploads">
                                          <PlusCircle className="plus-down-add me-0" />
                                          <h4>{t?.[l]?.["upload_video"] || "Upload Video"}</h4>
                                        </div>
                                      </div> */}
                                      <div className="image-upload">
                                        <input
                                          id="videoUpload"
                                          type="file"
                                          accept="video/mp4,video/webm,video/ogg,video/avi,video/mov,video/mkv"
                                          onChange={handleVideoUpload}
                                        />
                                        <label htmlFor="videoUpload" className="image-uploads" style={{ display: "block", cursor: "pointer" }}>
                                          <PlusCircle className="plus-down-add me-0" />
                                          <h4>{t?.[l]?.["upload_video"] || "Upload Video"}</h4>
                                        </label>
                                      </div>
                                      {imageLoading > 0 && <Spinner />}
                                    </div>

                                    {videoUrl && (
                                      <div className="phone-img border rounded p-2 position-relative">
                                        <Link
                                          to="#"
                                          onClick={(e) => { e.preventDefault(); handleRemoveVideo(); }}
                                          className="position-absolute top-0 end-0 m-2"
                                        >
                                          <X className="x-square-add remove-product text-danger" />
                                        </Link>

                                        <video width="320" height="200" controls className="img-fluid img-thumbnail" style={{ maxWidth: "170px" }}>
                                          <source
                                            src={videoUrl.startsWith("http") ? videoUrl : bucketObj.bucketUrl + bucketObj.objectKey + videoUrl}
                                            type="video/mp4"
                                          />
                                          Your browser does not support the video tag.
                                        </video>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              )}
                            </div>

                            {/* YouTube Meta (only when YouTube selected) */}
                            {showYoutubeMeta && (
                              <div className="mb-3 add-product produt-name-type d-flex align-items-start flex-wrap">
                                <div className="col-lg-6 col-12 mb-3">
                                  <div className="me-4">
                                    <label className="form-label">YouTube Title</label>
                                    <input
                                      type="text"
                                      name="youtubeMeta.title"
                                      className="form-control"
                                      maxLength={100}
                                      value={product.youtubeMeta?.title || ""}
                                      onChange={handleInputChange}
                                      placeholder="Video title"
                                      required
                                    />
                                  </div>
                                </div>

                                <div className="col-lg-6 col-12 mb-3">
                                  <div className="me-4">
                                    <label className="form-label">Privacy </label>
                                    <Select
                                      required
                                      className="select"
                                      options={YT_PRIVACY}
                                      name="youtubeMeta.privacyStatus"
                                      value={YT_PRIVACY.find(o => o.value === product.youtubeMeta?.privacyStatus) || YT_PRIVACY[0]}
                                      onChange={(opt) =>
                                        handleInputChange({ target: { name: "youtubeMeta.privacyStatus", value: opt.value } })
                                      }
                                    styles={{
                                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                      menu: (base) => ({ ...base, zIndex: 9999 }),
                                    }}
                                    />
                                  </div>
                                </div>

                                <div className="col-lg-12 col-12 mb-3">
                                  <div className="me-4">
                                    <label className="form-label">Description</label>
                                    <textarea
                                      name="youtubeMeta.description"
                                      className="form-control"
                                      rows={4}
                                      maxLength={5000}
                                      value={product.youtubeMeta?.description || ""}
                                      onChange={handleInputChange}
                                      placeholder="Describe your video"
                                    />
                                  </div>
                                </div>

                                {/* <div className="col-lg-6 col-12 mb-3">
                                  <div className="me-4">
                                    <label className="form-label">Tags (comma separated)</label>
                                    <input
                                      type="text"
                                      name="youtubeMeta.tagsCsv"
                                      className="form-control"
                                      value={product.youtubeMeta?.tagsCsv || ""}
                                      onChange={handleInputChange}
                                      placeholder="cars, japan import, mark x"
                                    />
                                  </div>
                                </div> */}

                                <div className="col-lg-6 col-12 mb-3">
                                  <div className="me-4">
                                    <label className="form-label">Category <span>*</span></label>
                                    <Select
                                      className="select"
                                      options={YT_CATEGORIES}
                                      name="youtubeMeta.categoryId"
                                      required
                                      value={YT_CATEGORIES.find(o => o.value === product.youtubeMeta?.categoryId) || null}
                                      onChange={(opt) =>
                                        handleInputChange({ target: { name: "youtubeMeta.categoryId", value: opt?.value || "" } })
                                      }
                                      placeholder="Choose a category"
                                    styles={{
                                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                      menu: (base) => ({ ...base, zIndex: 9999 }),
                                    }}
                                    />
                                  </div>
                                </div>

                                {/* <div className="col-lg-6 col-12 mb-3">
                                  <div className="me-4">
                                    <label className="form-label">Default Language</label>
                                    <Select
                                      className="select"
                                      options={LANGUAGES}
                                      name="youtubeMeta.defaultLanguage"
                                      value={LANGUAGES.find(o => o.value === product.youtubeMeta?.defaultLanguage) || null}
                                      onChange={(opt) =>
                                        handleInputChange({ target: { name: "youtubeMeta.defaultLanguage", value: opt?.value || "" } })
                                      }
                                      placeholder="Select language"
                                    />
                                  </div>
                                </div> */}

                                <div className="col-lg-6 col-12 mb-3">
                                  <div className="me-4">
                                    <label className="form-label d-block">Made for Kids?</label>
                                    <div className="form-check">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="ytKids"
                                        name="youtubeMeta.madeForKids"
                                        checked={!!product.youtubeMeta?.madeForKids}
                                        onChange={handleInputChange}
                                      />
                                      <label className="form-check-label" htmlFor="ytKids">Yes</label>
                                    </div>
                                  </div>
                                </div>

                                {/* <div className="col-lg-6 col-12 mb-3">
                                  <div className="me-4">
                                    <label className="form-label">Custom Thumbnail (optional)</label>
                                    <div className="input-blocks">
                                      <div className="image-upload">
                                        <input type="file" accept="image/*" onChange={handleYtThumbUpload} />
                                        <div className="image-uploads">
                                          <PlusCircle className="plus-down-add me-0" />
                                          <h4>Upload Thumbnail</h4>
                                        </div>
                                      </div>
                                    </div>
                                    {ytThumbUrl && (
                                      <div className="mt-2">
                                        <img
                                          src={toAbs(ytThumbUrl)}
                                          alt="thumbnail"
                                          style={{ width: 200, height: "auto", borderRadius: 6 }}
                                        />
                                      </div>
                                    )}
                                  </div>
                                </div> */}
                              </div>
                            )}

                            {/* Collage preview */}
                            {collageSetting && product.postingType === "collage" && (
                              <div className="photo-collage" ref={collageRef}>
                                <ReactPhotoCollage {...collageSetting} />
                              </div>
                            )}
                          </div>
                        </div>

                        {/* Basic fields */}
                        <div className="row mt-3">
                          <div className="col-lg-6 col-sm-6 col-12">
                            <div className="me-4">
                              <label className="form-label">{t?.[l]?.["post_name"] || "Post Name"}</label>
                              <input
                                type="text"
                                placeholder={t?.[l]?.["post_name"] || "Post Name"}
                                className="form-control"
                                value={product.title || ""}
                                required
                                name="title"
                                onChange={handleInputChange}
                                disabled={enabled}
                              />
                            </div>
                          </div>

                          {/* Scheduling */}
                          <div className="col-lg-6 col-12 mb-3">
                            <div className="me-4">
                              <label className="form-label">{t?.[l]?.["schedule_type"] || "Schedule Type"} <span>*</span></label>
                              <select
                                className="form-control"
                                value={product.scheduleType || "none"}
                                name="scheduleType"
                                onChange={handleInputChange}
                              >
                                <option value="none">{t?.[l]?.["select"] || "Select"}</option>
                                <option value="now">{t?.[l]?.["post_now"] || "Post Now"}</option>
                                <option value="custom">{t?.[l]?.["custom"] || "Custom"}</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          { product.scheduleType === "custom" && (
                            <div className="col-lg-6 col-12 mb-3">
                              <label className="form-label">{t?.[l]?.["schedule_date"] || "Schedule Date"} <span>*</span></label>
                              <input
                                type="date"
                                className="form-control"
                                value={product.scheduleDate || ""}
                                name="scheduleDate"
                                onChange={handleInputChange}
                              />
                            </div>
                          )}

                          {(product.scheduleType === "daily" || product.scheduleType === "weekly" || product.scheduleType === "custom") && (
                            <div className="col-lg-6 col-12 mb-3">
                              <label className="form-label">{t?.[l]?.["schedule_time"] || "Schedule Time"} <span>*</span></label>
                              <input
                                type="time"
                                className="form-control"
                                value={product.scheduleTime || ""}
                                name="scheduleTime"
                                onChange={handleInputChange}
                              />
                            </div>
                          )}
                        </div>

                        {/* <div className="col-lg-12">
                          <div className="input-blocks summer-description-box transfer mb-3">
                            <div className="me-4">
                              <label className="form-label">{t?.[l]?.["suggestion"] || "Suggestion"}</label>
                              <textarea
                                className="form-control"
                                value={product.text || ""}
                                name="text"
                                onChange={handleInputChange}
                                maxLength={250}
                              />
                            </div>
                          </div>
                        </div> */}
                        {isNonYoutubeSelected && (
                           <div className="col-lg-12">
                             <div className="input-blocks summer-description-box transfer mb-3">
                               <div className="me-4">
                                 <label className="form-label">
                                   {t?.[l]?.["caption_description"] || "Caption / Description"}
                                 </label>
                                 <textarea
                                   className="form-control"
                                   value={product.text || ""}
                                   name="text"
                                   onChange={handleInputChange}
                                   maxLength={1000}  // give a bit more room than 250 if you want
                                   placeholder={t?.[l]?.["caption_placeholder"] || "Write a caption for Facebook / Instagram / TikTok etc."}
                                 />
                               </div>
                             </div>
                           </div>
                         )}
                      </div>
                    </div>
                    {/* /accordion-body */}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {!enabled && (
            <div className="col-lg-12">
              <div className="btn-addproduct mb-4">
                <button type="button" className="btn btn-cancel me-2" onClick={goBack}>
                  {t?.[l]?.["cancel"] || "Cancel"}
                </button>
                <button type="submit" className="btn btn-submit">
                  {t?.[l]?.[(btnLoading || imageLoading) ? "wait" : "save"] || ((btnLoading || imageLoading) ? "Wait..." : "Save")}
                </button>
              </div>
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default AddSocialVideoSchedulingAi;



  // const submit = useCallback(
  //   async (event) => {
  //     event.preventDefault();
  //     event.stopPropagation();

  //     try {
  //       let postingUrl;

  //       if (product.postingType === "collage") {
  //         const name = getImageName("ReactPhotoCollage.png", "socialmedia", "img");
  //         await generateCollage(name);
  //         postingUrl = name;
  //       }

  //       setBtnLoading(true);

  //       const finalProduct = { ...product };
  //       const platforms = Array.isArray(finalProduct.platforms)
  //         ? finalProduct.platforms.map(String)
  //         : finalProduct.platforms
  //         ? [String(finalProduct.platforms)]
  //         : [];
  //       finalProduct.platforms = platforms;

  //       // schedule validation
  //       const now = new Date();
  //       now.setMilliseconds(0);
  //       now.setSeconds(0);

  //       if (finalProduct.scheduleType && finalProduct.scheduleType !== "now" && finalProduct.scheduleTime) {
  //         const [hh, mm] = String(finalProduct.scheduleTime).split(":");
  //         const sched = new Date();
  //         if (finalProduct.scheduleDate) {
  //           const d = new Date(finalProduct.scheduleDate);
  //           sched.setFullYear(d.getFullYear(), d.getMonth(), d.getDate());
  //         }
  //         sched.setHours(+hh || 0, +mm || 0, 0, 0);
  //         if (sched < new Date(now.getTime() + 2 * 60 * 1000)) {
  //           setBtnLoading(false);
  //           return MySwal.fire({
  //             icon: "error",
  //             title: "Pick a future time (≥10 minutes ahead)",
  //             timer: 2500,
  //             showConfirmButton: false,
  //           });
  //         }
  //         finalProduct.isInstant = false;
  //       } else {
  //         finalProduct.isInstant = finalProduct.scheduleType === "now" || !finalProduct.scheduleType;
  //       }

  //       // page/channel presence
  //       const hasFbRaw = platforms.includes("facebook");
  //       const hasIgRaw = platforms.includes("instagram");
  //       const hasYtRaw = platforms.includes("youtube");

  //       const hasFbPage = platforms.some((p) => p?.startsWith?.("facebook-"));
  //       const hasIgPage = platforms.some((p) => p?.startsWith?.("instagram-"));
  //       const hasYtChannel = platforms.some((p) => p?.startsWith?.("youtube-"));

  //       if (
  //         (hasFbRaw && !hasFbPage && !finalProduct.page) ||
  //         (hasIgRaw && !hasIgPage && !finalProduct.page) ||
  //         (hasYtRaw && !hasYtChannel && !finalProduct.channelId)
  //       ) {
  //         setBtnLoading(false);
  //         return MySwal.fire({
  //           icon: "warning",
  //           title: "Please select a page/channel",
  //           timer: 2200,
  //           showConfirmButton: false,
  //         });
  //       }

  //       // derive channelId if user selected youtube-xxx
  //       if (!finalProduct.channelId) {
  //         const ytPick = platforms.find((p) => p.startsWith?.("youtube-"));
  //         if (ytPick) finalProduct.channelId = ytPick.split("youtube-")[1];
  //       }

  //       // Always attach common
  //       finalProduct.userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  //       finalProduct.postingUrl = postingUrl;
  //       finalProduct.reelUrl = videoUrl || undefined;
  //       finalProduct.aiPromptFromSheet =
  //         t?.[l]?.["post_ai_prompt"] || "Please write social media post, max 100 words.";
  //       finalProduct.auto = isAutoPosting;
        
  //       // If any of FB/IG/YT selected, allow (and for YT, require) video
  //       const wantsVideo = hasFbRaw || hasFbPage || hasIgRaw || hasIgPage || hasYtRaw || hasYtChannel;

  //       // YouTube-specific validations
  //       if (hasYtRaw || hasYtChannel) {
  //         const m = finalProduct.youtubeMeta || {};
  //         // delete m.tagsCsv;
  //         if (!finalProduct.reelUrl) {
  //           setBtnLoading(false);
  //           return MySwal.fire({ icon: "warning", title: "Please attach a video for YouTube", timer: 2200, showConfirmButton: false });
  //         }
  //         if (!m.title?.trim()) {
  //           setBtnLoading(false);
  //           return MySwal.fire({ icon: "warning", title: "YouTube title is required", timer: 2000, showConfirmButton: false });
  //         }
  //         if (!m.privacyStatus) {
  //           setBtnLoading(false);
  //           return MySwal.fire({ icon: "warning", title: "Select YouTube privacy", timer: 2000, showConfirmButton: false });
  //         }
  //         if (!m.categoryId) {
  //           setBtnLoading(false);
  //           return MySwal.fire({ icon: "warning", title: "Choose a YouTube category", timer: 2000, showConfirmButton: false });
  //         }

  //         // Normalize tags array for backend
  //         // const tags = (m.tagsCsv || "")
  //         //   .split(",")
  //         //   .map((s) => s.trim())
  //         //   .filter(Boolean);
  //         // delete m.tagsCsv;
  //         finalProduct.youtubeMeta = {
  //           ...m,
  //           // tags,
  //           // thumbnailUrl: m.thumbnailUrl || ytThumbUrl || "",
  //         };
  //       }

  //       // For FB/IG posting a video, we simply include reelUrl (already handled)
  //       if (wantsVideo && !finalProduct.reelUrl) {
  //         // Not strictly required for FB/IG in all cases, so this is a soft warning only if YT not selected.
  //         // You can change to a hard error if you want to enforce video presence.
  //       }

  //       const res = await axios.post("addorupdatescheduledpostai/", finalProduct);
  //       setBtnLoading(false);
  //       if (res) {
  //         await MySwal.fire({
  //           position: "top-end",
  //           icon: "success",
  //           title: "Post added successfully!",
  //           timer: 2000,
  //           showConfirmButton: false,
  //         });
  //         goBack();
  //       }
  //     } catch (err) {
  //       setBtnLoading(false);
  //       MySwal.fire({
  //         position: "top-end",
  //         icon: "error",
  //         title: err?.response?.data?.message || "Error",
  //         showConfirmButton: false,
  //         timer: 3000,
  //       });
  //     }
  //   },
  //   [MySwal, generateCollage, isAutoPosting, l, t, product, videoUrl] // ytThumbUrl
  // );